import styled from 'styled-components'
import Color from 'color'

export const ViewButton = styled.button`
  background: none;
  border: none;
  width: 37px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-top: 1px solid #e6e8eb;
  border-bottom: 1px solid #e6e8eb;
  border-right: 1px solid #e6e8eb;

  svg {
    width: 20px;
    height: 20px;
    stroke: #a1a5b0;
  }

  &.active {
    background-color: ${({ theme }) =>
      Color(theme.primaryColor).lightness(99).string()};
  }

  &.active,
  &:hover {
    svg {
      stroke: ${({ theme }) => theme.primaryColor};
    }
  }

  &:focus-visible {
    z-index: 1;
    outline: 1px solid #a1a5b0;
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;

    &:hover {
      svg {
        stroke: #a1a5b0;
      }
    }
  }
`

export const Wrapper = styled.div`
  background: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;

  > div:first-child {
    ${ViewButton} {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-left: 1px solid #e6e8eb;
    }
  }

  > div:last-child {
    ${ViewButton} {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`
